export default {
  GET_ADMIN_REPOSITORIES: 'getAdminRepositories',
  GET_ALL_REPOSITORIES: 'getAllRepositories',
  SAVE_REPOSITORY: 'saveRepository',
  SAVE_GDRIVE_CONFIG: 'saveGDriveConig',
  GET_GDRIVE_CONFIG: 'getGDriveConig',
}
